import React, { useState } from 'react';
import { Link } from "react-router-dom";

import DocsVideo from '../reusable_components/DocsVideo';

import schedule_type from '../images/schedule_type.png';

import schedule_structure_add_a_day from '../videos/schedule_structure_add_a_day.mov';
import schedule_structure_remove_a_day from '../videos/schedule_structure_remove_a_day.mov';
import schedule_structure_add_a_period from '../videos/schedule_structure_add_a_period.mov';
import schedule_structure_remove_a_period from '../videos/schedule_structure_remove_a_period.mov';
import schedule_structure_change_period_order from '../videos/schedule_structure_change_period_order.mov';
import schedule_structure_change_period_name from '../videos/schedule_structure_change_period_name.mov';
import schedule_structure_change_period_time from '../videos/schedule_structure_change_period_time.mov';
import schedule_structure_include_in_match from '../videos/schedule_structure_include_in_match.mov';
import schedule_structure_add_a_lunch from '../videos/schedule_structure_add_a_lunch.mov';
import schedule_structure_remove_a_lunch from '../videos/schedule_structure_remove_a_lunch.mov';
import schedule_structure_change_lunch_name from '../videos/schedule_structure_change_lunch_name.mov';
import schedule_structure_change_lunch_time from '../videos/schedule_structure_change_lunch_time.mov';
import schedule_structure_add_a_rotating_period from '../videos/schedule_structure_add_a_rotating_period.mov';
import schedule_structure_remove_a_rotating_period from '../videos/schedule_structure_remove_a_rotating_period.mov';
import schedule_structure_set_rotating_periods from '../videos/schedule_structure_set_rotating_periods.mov';
import schedule_structure_unset_rotating_periods from '../videos/schedule_structure_unset_rotating_periods.mov';
import schedule_structure_change_rotating_period_name from '../videos/schedule_structure_change_rotating_period_name.mov';

export default function ScheduleStructureDocs({ topic, setTopic, schoolType, scrollToInstructions }) {
	const [scheduleType, setScheduleType] = useState(null);
	
	const topics = [{type:'schedule_type', name: 'Choosing Schedule Type'}, {type:'schedule_structure', name: 'Schedule Structure'}];
	const schedule_types = ['daily', 'block', 'a/b', 'a/b + skinny', 'custom'];
	const schedule_structure_options = [
		{
			id:'add_a_day',
			title:'Add a day',
			description:"To add a day onto the cycle just click the '+' button next to the last day tab.",
			img_type:'video',
			img: schedule_structure_add_a_day,
			schedule_types: ['block', 'custom']
		},
		{
			id:'remove_a_day',
			title:'Remove a day',
			description:"To remove a day onto the cycle just click the 'x' on the day tab.",
			img_type:'video',
			img: schedule_structure_remove_a_day,
			schedule_types: ['block', 'custom']
		},
		{
			id:'add_a_period',
			title:'Add a period',
			description:"To add a period just click the 'Add a Period' button.",
			img_type:'video',
			img: schedule_structure_add_a_period,
			schedule_types: ['daily', 'block', 'a/b', 'a/b + skinny', 'custom']
		},
		{
			id:'remove_a_period',
			title:'Remove a period',
			description:"To remove a period just click the 'x' in the corner of a period.",
			img_type:'video',
			img: schedule_structure_remove_a_period,
			schedule_types: ['daily', 'block', 'a/b', 'a/b + skinny', 'custom']
		},
		{
			id:'change_period_order',
			title:'Change period order',
			description:"To change the order of your existing periods, just drag and drop the periods where you want them.",
			img_type:'video',
			img: schedule_structure_change_period_order,
			schedule_types: ['daily', 'block', 'a/b', 'a/b + skinny', 'custom']
		},
		{
			id:'change_period_name',
			title:'Change period name',
			description:"To change a period name, just click on the edit button next to the period name, type your period name, and then clicking the check mark to confirm.",
			img_type:'video',
			img: schedule_structure_change_period_name,
			schedule_types: ['daily', 'block', 'a/b', 'a/b + skinny', 'custom']
		},
		{
			id:'change_period_time',
			title:'Change period time',
			description:"To change a period time, just input your period times into the time input.",
			img_type:'video',
			img: schedule_structure_change_period_time,
			schedule_types: ['daily', 'block', 'a/b', 'a/b + skinny', 'custom']
		},
		{
			id:'include_in_match',
			title:'Include in match?',
			description:"Sometimes students don't take classes in every period you set up (like a Zero Period before school). If you don't want this period to be used to calculate whether a student has a full schedule, then unselect the 'Include in Match' option.",
			img_type:'video',
			img: schedule_structure_include_in_match,
			schedule_types: ['daily', 'block', 'a/b', 'a/b + skinny', 'custom']
		},
		{
			id:'add_a_lunch',
			title:'Add a lunch',
			description:"To add a lunch just click the 'Add a Lunch' button.",
			img_type:'video',
			img: schedule_structure_add_a_lunch,
			schedule_types: ['daily', 'block', 'a/b', 'a/b + skinny', 'custom']
		},
		{
			id:'remove_a_lunch',
			title:'Remove a lunch',
			description:"To remove a lunch just click the 'x' in the corner of a lunch.",
			img_type:'video',
			img: schedule_structure_remove_a_lunch,
			schedule_types: ['daily', 'block', 'a/b', 'a/b + skinny', 'custom']
		},
		{
			id:'change_lunch_name',
			title:'Change lunch name',
			description:"To change a lunch name, just click on the edit button next to the lunch name, type your lunch name, and then clicking the check mark to confirm.",
			img_type:'video',
			img: schedule_structure_change_lunch_name,
			schedule_types: ['daily', 'block', 'a/b', 'a/b + skinny', 'custom']
		},
		{
			id:'change_lunch_time',
			title:'Change lunch time',
			description:"To change a lunch time, just input your lunch times into the time input.",
			img_type:'video',
			img: schedule_structure_change_lunch_time,
			schedule_types: ['daily', 'block', 'a/b', 'a/b + skinny', 'custom']
		},
		{
			id:'add_rotating_period',
			title:'Add a rotating period',
			description:"To add a rotating period just click the 'Add a Rotating Period' button.",
			img_type:'video',
			img: schedule_structure_add_a_rotating_period,
			schedule_types: ['block', 'a/b', 'a/b + skinny', 'custom']
		},
		{
			id:'remove_rotating_period',
			title:'Remove a rotating period',
			description:"To remove a rotating period just click the 'x' in the corner of a rotating period.",
			img_type:'video',
			img: schedule_structure_remove_a_rotating_period,
			schedule_types: ['block', 'a/b', 'a/b + skinny', 'custom']
		},
		{
			id:'set_rotating_period',
			title:'Set rotating periods',
			description:"To set up your rotation, drag your rotating periods into the periods on the left.",
			img_type:'video',
			img: schedule_structure_set_rotating_periods,
			schedule_types: ['block', 'a/b', 'a/b + skinny', 'custom']
		},
		{
			id:'unset_rotating_period',
			title:'Unset rotating periods',
			description:"To unset a rotating period, click the 'x' that is on any rotating period that is already set.",
			img_type:'video',
			img: schedule_structure_unset_rotating_periods,
			schedule_types: ['block', 'a/b', 'a/b + skinny', 'custom']
		},
		{
			id:'change_rotating_period_name',
			title:'Change rotating period name',
			description:"To change a rotating period name, just click on the edit button in the bottom right of your rotating period, type your rotating period name, and then clicking the check mark to confirm.",
			img_type:'video',
			img: schedule_structure_change_rotating_period_name,
			schedule_types: ['block', 'a/b', 'a/b + skinny', 'custom']
		}
	];
	
	const chooseTopic = (new_topic) => {
		setTopic(new_topic);
	}
	
	const chooseScheduleType = (schedule_type) => {
		setScheduleType(schedule_type);
	}
	
	return (
		<div className='documentation-page'>
			<div className='step-main-heading'>Schedule Structure</div>
			<p className='documentation-question-heading'>What do you need help with?</p>
			<div className='choose-topic'>
				{topics.map((topic_option, i) => (
					<Link className={`choose-topic-btn ${topic_option.type === topic ? 'choose-topic-btn-selected' : ''}`} to={`/app/${schoolType}/documentation/scheduling_wizard/schedule_structure/${topic_option.type}`} onClick={() => chooseTopic(topic_option.type)} key={i}>{topic_option.name}</Link>	
				))}
			</div>
			{topic === 'schedule_type' &&
				<div className='documentation-container'>
					<h2 className='documentation-page-heading'>Choosing Schedule Type</h2>
					<img className='documentation-screen-image' src={schedule_type} alt='schedule type'/>
					<p className='documentation-question-heading'>What do these schedule types mean?</p>
					<p><strong className='turquoise-text'>Daily Schedule</strong><br></br>A daily schedule is one where you have same periods every day, same classes every day.</p>
					<p><strong className='turquoise-text'>Block Schedule</strong><br></br>A block schedule is one where courses move or rotate depending on the day of the week.</p>
					<p><strong className='turquoise-text'>A/B Schedule</strong><br></br>An A/B schedule is one where you have one set of courses running on A day and a different set of courses running on B day, and these days alternate.</p>
					<p><strong className='turquoise-text'>A/B + Skinny Schedule</strong><br></br>An A/B schedule is the same as an A/B schedule, except there is one day a week when all classes meet.</p>
					<p className='documentation-question-heading'>What should I do if my schedule is unique?</p>
					<div style={{marginTop:'10px'}}>If you have a unique schedule please choose the <span className='highlight'>Custom</span> option.</div>
				</div>
			}
			{topic === 'schedule_structure' &&
				<div className='documentation-container'>
					<h2 className='documentation-page-heading'>Schedule Structure</h2>
					<p className='documentation-question-heading'>Which schedule type do you have?</p>
					<div className='choose-topic'>
						{schedule_types.map((schedule_type, index) => (
							<div className={`choose-topic-btn capitalize ${schedule_type === scheduleType ? 'choose-topic-btn-selected' : ''}`} key={index} onClick={() => chooseScheduleType(schedule_type)}>{schedule_type}</div>
						))}
					</div>
					{scheduleType &&
						<div className='documentation-step-container'>
							<h2 className='documentation-container-text-heading turquoise-text'><strong><span className='capitalize'>{scheduleType}</span> Schedules</strong></h2>
							<div>What are you looking to do?</div>
							<div className='documentation-container-instruction-option-container'>
								{schedule_structure_options.map((schedule_structure_option, i) => {
									const option_applies_to_this_schedule_type = schedule_structure_option.schedule_types.includes(scheduleType);
									if(!option_applies_to_this_schedule_type) return null;

									return (
										<div className='documentation-container-instruction-option blue-link' onClick={() => scrollToInstructions(schedule_structure_option.id)} key={i}>{schedule_structure_option.title}</div>
									)
								})}
							</div>
							{schedule_structure_options.map((schedule_structure_option, j) => {
								const option_applies_to_this_schedule_type = schedule_structure_option.schedule_types.includes(scheduleType);
								if(!option_applies_to_this_schedule_type) return null;

								return (
									<div id={`${schedule_structure_option.id}`} className='documentation-container-instruction-container' key={j}>
										<div className='documentation-container-instruction-heading'>{schedule_structure_option.title}</div>
										<div className='documentation-container-instruction-description'>{schedule_structure_option.description}</div>
										{(schedule_structure_option.img_type === 'video') ?
											(
												<DocsVideo src={schedule_structure_option.img}></DocsVideo>
											):(
												<img className='documentation-screen-image' style={{width:'100%'}} src={schedule_structure_option.img} alt={schedule_structure_option.title} />
											)

										}
									</div>
								)
							})}
						</div>
					}
				</div>
			}
		</div>
	);
}
